import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormInput } from '../base-form-input';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { SelectOption } from '@nuso/forms/data-access';
import { startWith, map } from 'rxjs/operators';

@Component({
    selector: 'nuso-autocomplete-input',
    templateUrl: './autocomplete-input.component.html',
    styleUrls: ['./autocomplete-input.component.css'],
    standalone: false
})
export class AutocompleteInputComponent extends BaseFormInput implements OnInit {
  filteredOptions: Observable<SelectOption[]> | null;

  override ngOnInit() {
    super.ngOnInit();
    this.filteredOptions = !this.field || !this.field.control ? null : this.field.control.valueChanges
      .pipe(
        startWith(''),
        map(
          value => !value || value === ''
            ? (this.field.options || [])
            : (this.field.options || []).filter(o => ((o.label ?? '').toLowerCase()).startsWith(((`${value}`).toLowerCase())))
        )
      );
  }

  displayLabel(value: any) {
    return !this.field ? null : _.get((this.field.options || []).find(x => x.value === value), 'label');
  }
}
